import { Component, OnInit,ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { AlertService,UserService } from '../_services/index';
declare let $: any;
import { DatePipe } from '@angular/common';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-viewreservation',
  templateUrl: './viewreservation.component.html',
  styleUrls: ['./viewreservation.component.css'],
})

export class ViewreservationComponent{
   backendUrl:any; 
	 data:any
	 id:any
   lang_value:any;
 constructor(fb: FormBuilder,private http: Http,private datePipe: DatePipe,private activatedRoute: ActivatedRoute,private translate:TranslateService) {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));         
      let u_locale=currentUser.user_locale ? currentUser.user_locale: 'en_US';
      if (u_locale.indexOf("_")!= -1){
          let arr=u_locale.split('_'); 
              u_locale=arr[0];                    
          }
      else{
            u_locale='en';
          }
      this.translate.setDefaultLang(u_locale);
  }

    ngOnInit() {
      this.translate.get(['valid_requied','invalid_name','restaurant_is_closed','please_select_branch_first','please_select_time','your_booking_updated','your_booking_deleted_successfully']).subscribe(res => {
           this.lang_value=res;
        });
      let url=window.location.hostname;
    //  if(url=='app.foodbot.ai' || url=='dashboard.foodbot.ai'){this.backendUrl=environment.prod}
    //  else if(url=='stage.foodbot.ai'){ this.backendUrl=environment.stage}
    //  else if(url=='uat.foodbot.ai'){ this.backendUrl=environment.uat}  
    //  else{ this.backendUrl=environment.local}
    if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage } 
    else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat } 
    else if (url == '127.0.0.1') { this.backendUrl = environment.local } 
    else { 
      this.backendUrl=window.location.origin
      this.backendUrl+="/apis"
    }
    	this.activatedRoute.params.subscribe((params: Params) => {
        this.id = params['id'];
      //  console.log(this.id);
      });
     
     let sql="SELECT DATE_FORMAT(a.reserve_date, '%d-%b-%Y') as re_date,DATE_FORMAT(a.reserve_from, '%H:%i') as from_time,DATE_FORMAT(a.reserve_to, '%H:%i') as to_time,DATE_FORMAT(a.date_time, '%d-%b-%Y') as dt,a.*,b.profile_pic,c.branch_name,if(a.source='webview','Self','Admin') AS b_by FROM `fb_book_meeting_room` a left join fb_user_profiles b on a.booked_by=b.sender_id left join fb_branches c on a.branch_id=c.branch_id where  a.id="+this.id;
     //console.log(sql);
     let headers = new Headers ({  'Content-Type': 'application/json' });
     let options = new RequestOptions({ headers: headers, method: "post" });
        
      this.http.post(this.backendUrl+'/getdata',JSON.stringify({'query': sql}),options)
            .map(data => data.json())
            .subscribe(data => {
          this.data = data;
          //console.log("I CANT SEE DATA HERE: ", this.data);
        });

  }
  

  roomName(branch_id,room_id){
       //console.log("branch_id,room_id",branch_id,room_id);
       let brList=[2360,2030,1521,1349,272,1362,2288,1896,1353,2260,1347,1582,1512,1351,1583,1539,1342,1334,1359,2325,2137,1695];
        if ( brList.indexOf(branch_id) != -1 ) {
          if(room_id == 1){
             return 'Sala de juntas';
          }else{
            return 'Sala de Cine';
          }
        }
        else if (branch_id == '1380') {
          if(room_id == 1){
            return 'SALA OPERA';
          }else{
            return 'SALA CHICAGO';
          }  
        }
        else if (branch_id == '1356') {
          if(room_id == 1){
            return 'Sala 1';
          }else{
            return 'Sala 2';
          }
        }
        else if (branch_id == '1520') {
          if(room_id == 1){
            return 'Saturno';
          }else{
            return 'Venus';
          }
        }else{
           return '--'
        }
  }

}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/viewreservation/viewreservation.component.ts